import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { hasDuplicateElementName } from './util';
import type { IState } from '../../../stores/model/metamodel/state';

/**
 * Check if an FSM has duplicate states (i.e. two states with the same
 * name or > 1 initial states).
 */
class StateDuplicateCheck extends Check<IState> {
  static description = 'Check for duplicate states';

  check(): Report {
    this.report = new Report();
    const list = this.element.fsm.states;
    if (hasDuplicateElementName(list, this.element)) {
      this.report.addMessage(
        MessageType.ERROR,
        `State with the same name (${this.element.name}) found.`,
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No state with the same name found.',
        this,
        this.element
      );
    }

    if (this.element.type === 'INITIAL_STATE') {
      // Check if another initial state exists
      if (list.some(s => s !== this.element && s.type === 'INITIAL_STATE')) {
        this.report.addMessage(
          MessageType.ERROR,
          `FSM already has an initial state.`,
          this,
          this.element
        );
      } else {
        this.report.addMessage(
          MessageType.INFORMATION,
          'No other initial state found.',
          this,
          this.element
        );
      }
    }
    return this.report;
  }
}

export default StateDuplicateCheck;
